<template>
  <div id="news">
    <!-- 主体 -->
    <div class="row-nowrap">
      <div id="subject-news-body">
        <div v-for="item in newsList" :key="item.id">
          <div class="news-item" @click="goToDetail(item.id)">
            <div
              class="row-nowrap"
              :style="{
                display: 'flex',
                border:
                  showBorder == 2
                    ? '2px solid #FFF'
                    : showBorder == 1
                    ? '2px solid #000'
                    : '0px',
              }"
            >
              <div style="width: 120px; height: 67px">
                <img
                :src="getImageURL(parseUrl(item.cover)[0])"
                style="width: 120px; height: 67px;"
              />
              </div>

              <div class="news-text">
                <div>
                  <p class="title">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request, {
  getCategoriesByType,
  getResourceNewsCon,
} from "@/utils/request";
import { getImageURL as _getImageURL } from "@/utils/zgly-utils.js";

export default {
  head() {
    return {
      link: [{ rel: "canonical", href: "/news/all" }],
    };
  },
  components: {},
  props: {
    newsList: {
      type: Array,
    },
    showBorder: {
      type: Number,
    },
  },
  data() {
    return {
      currentList: [],
      //   newsList: [],
      // 分页信息
      pageInfo: {
        total: 0,
        page: 1,
        size: 3,
      },
    };
  },
  mounted() {
    // this.pageInfo.total = this.$props.newsList.length;
    // this.listNews(this.pageInfo.page, this.pageInfo.size);
  },

  methods: {
    listNews(offset, size) {
      if (this.$props.newsList.length < offset * size) {
        this.currentList = this.$props.newsList.slice((offset - 1) * size);
      } else {
        this.currentList = this.$props.newsList.slice(
          (offset - 1) * size,
          size
        );
      }
    },
    textAdapt(val) {
      if (typeof val == "string") {
        var txt = new RegExp("<.+?>", "g");
        txt = val.replace(txt, "");
        return txt.replace(/&nbsp;/gi, "");
      }
      return "";
    },
    pageChange() {
      this.listNews(this.pageInfo.page, this.pageInfo.size);
    },
    parseUrl(url) {
      let imgArr = url.split(",");
      if (typeof imgArr === "string") {
        imgArr = [imgArr];
      }
      imgArr.map((_) => {
        _ = this.getImageURL(_);
        return _;
      });
      return imgArr;
    },
    getImageURL(cover) {
      return _getImageURL(cover);
    },
    goToDetail(id) {
      this.$router.push({ path: `/news/details/${id}` });
    },
  },
};
</script>

<style lang="less" scope>
#subject-news-body {
  margin: auto 10px;
  .news-item {
    margin: 1rem 0;
    overflow: hidden;
    .news-text {
      cursor: pointer;
      text-align: left;
      overflow: hidden;
      height: 67px;
      width: 100%;
      padding: 10px;
      background: #fff;
      div {
        .title {
          font-weight: bold;
          font-size: 12px;
          &:hover {
            color: coral;
          }
        }
        .time,
        .content {
          font-size: 14px;
          color: #959595;
        }
      }
    }
  }
}
</style>
